// extracted by mini-css-extract-plugin
export default {"root":"DetailedInfoCard_root__jVAer","section":"DetailedInfoCard_section__cw-u1","divider":"DetailedInfoCard_divider__kb6eX"};